import InfiniteViewerManager from "./InfiniteViewerManager";

export default class InfiniteViewer extends InfiniteViewerManager {}
